export const environment = {
  production: true,
  dashboardUrl: 'https://pluto-dash.herokuapp.com/api',
  wavesCapApiUrl: 'https://wavescap.com/api',
  tokensApiUrl: 'https://puzzle-py-api-feaf3dd76a7a.herokuapp.com/api/tokensList',
  nodeUrl: 'https://nodes.wavesnodes.com',
};
